export function getReviewMetaText(value: unknown): string {
  if (value == null) return '';
  if (typeof value === 'string' || typeof value === 'number') {
    return String(value).trim();
  }
  if (typeof value !== 'object') return '';

  const meta = value as Record<string, unknown>;
  for (const key of ['value', 'label', 'name', 'title']) {
    const nested = meta[key];
    if (typeof nested === 'string' || typeof nested === 'number') {
      const text = String(nested).trim();
      if (text) return text;
    }
  }

  return '';
}

export function parseReviewRating(value: string): number {
  const rating = parseFloat(value);
  return Number.isFinite(rating) ? Math.max(0, Math.min(5, rating)) : 0;
}
